import { useState, type FC } from "react";
import { Container, Title } from "../../shared/ui";
import { Link } from "react-router-dom";
import { ourOffices } from "./const/ourOffices";
import { getRouteVacancies } from "../../shared/constants/routes";
import { SearchParamsVacancyEnum } from "../../shared/constants/searchParams";

import styles from "./OurOffices.module.scss";
import { generateMediaQuery } from "../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../shared/constants/media";
import { useMediaQuery } from "../../shared/hooks/useMediaQuery";

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm);
const DEFAULT_VISIBLE_CITIES = 20;
const SHOW_ALL_CITIES = ourOffices.offices?.length;

export const OurOffices: FC = () => {
    const isMobile = useMediaQuery(mediaQuery);
    const defaultVisible = isMobile ? DEFAULT_VISIBLE_CITIES : SHOW_ALL_CITIES;
    const [visible, setVisible] = useState(defaultVisible);
    const hasMoreCities = visible < (ourOffices.offices?.length ?? 0);

    const handleShowMoreCard = () => {
        setVisible((prevValue) => prevValue + SHOW_ALL_CITIES);
    };

    const offices = ourOffices.offices?.slice(0, visible).map(({ city }, index) => (
        <li key={index}>
            <Link
                to={`${getRouteVacancies()}?${SearchParamsVacancyEnum.CITY}=${city}`}
                className={styles.ourOffices__link}
            >
                {city}
            </Link>
        </li>
    ));

    return (
        <div className={styles.ourOffices}>
            <div className={styles.scroll} id="office" />
            <Container marginSize="standard">
                <Title className={styles.ourOffices__title} level={3}>
                    Наша география
                </Title>
                <div className={styles.ourOffices__countryWrapper}>
                    <ul>{offices}</ul>
                </div>
                {hasMoreCities && (
                    <button onClick={handleShowMoreCard} className={styles.ourOffices__buttonLink}>
                        Показать все
                    </button>
                )}
            </Container>
            <div className={styles.ourOffices__bgImageMap}></div>
        </div>
    );
};
